import { DevicePlatform, EnrollmentStatus, Role } from '../enums';

export interface IPermissionData {
    devicePlatform?: DevicePlatform;
    enrollmentStatus?: EnrollmentStatus;
    role?: Role;
    vin?: string;
    commissionNumber?: string;
    commissionNumberYear?: string;
}

export enum PermissionGroup {
    PU_COMPLETED,
    PU_COMPLETED_MBB,
    PU,
    SU,
    GU,
    GU_WCAR,
    WCAR,
    MBB,
    VIN,
    COMMISSION
}

export class PermissionService {

    public hasPermission(permissionData: IPermissionData, ...permissionGroups: PermissionGroup[]) {
        return permissionGroups.filter((group) => this.hasSinglePermission(group, permissionData)).length > 0;
    }

    private hasSinglePermission(permissionGroup: PermissionGroup, permissionData: IPermissionData): boolean {
        // @formatter:off
        switch (permissionGroup) {
            case PermissionGroup.PU_COMPLETED:
                return permissionData.role === Role.PRIMARY_USER && permissionData.enrollmentStatus === EnrollmentStatus.COMPLETED;
            case PermissionGroup.PU_COMPLETED_MBB:
                return this.hasAllPermissions(permissionData, PermissionGroup.PU_COMPLETED, PermissionGroup.MBB);
            case PermissionGroup.PU:
                return permissionData.role === Role.PRIMARY_USER;
            case PermissionGroup.SU:
                return permissionData.role === Role.SECONDARY_USER;
            case PermissionGroup.GU:
                return permissionData.role === Role.GUEST_USER;
            case PermissionGroup.GU_WCAR:
                return permissionData.role === Role.GUEST_USER && permissionData.devicePlatform === DevicePlatform.WCAR;
            case PermissionGroup.WCAR:
                return permissionData.devicePlatform === DevicePlatform.WCAR;
            case PermissionGroup.MBB:
                return permissionData.devicePlatform === DevicePlatform.MBB || permissionData.devicePlatform === DevicePlatform.MBB_ODP;
            case PermissionGroup.VIN:
                return !!permissionData.vin;
            case PermissionGroup.COMMISSION:
                return !!permissionData.commissionNumber && !!permissionData.commissionNumberYear;
        }
        return false;
        // @formatter:on
    }

    private hasAllPermissions(permissionData: IPermissionData, ...permissionGroups: PermissionGroup[]) {
        return permissionGroups.filter((group) => this.hasSinglePermission(group, permissionData)).length === permissionGroups.length;
    }
}